import { Outlet, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { Flex } from '@chakra-ui/react';
import { useAuthRealm } from './AuthRealmAccessControl/AuthRealmContext';

const SignUpLayout = () => {
  const { userId } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { clientBrand } = useAuthRealm();

  const isAccountActivated = location.pathname.includes('account-activated');
  const isTokenFlow = searchParams.has('token');

  return (
    <Flex width="full" height="100vh" overflow="hidden">
      {/* Left side: dynamic content from nested routes */}
      <Flex flex="3" width={'full'} marginX={'auto'} overflowY={'hidden'}>
        <Outlet />
      </Flex>

      {/* Right side: fixed banner */}
      {(!userId || isAccountActivated) && !isTokenFlow && (
        <Flex height="full" flexGrow={3} flexBasis={0} display={{ base: 'none', md: 'flex' }}>
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: '100vh'
            }}
            className="image-container"
          >
            <img
              src={clientBrand.signupBackgroundImage}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'fill'
              }}
              alt="Description"
            />
          </div>
        </Flex>
      )}
    </Flex>
  );
};

export default SignUpLayout;
